import PortalIdParser from 'PortalIdParser';
import { getProperty } from 'customer-data-objects/model/ImmutableModel';
import { Avatar } from 'avatar-components/Avatar';
import { jsx as _jsx } from "react/jsx-runtime";
const ContactAvatar = ({
  contact,
  size = 'sm'
}) => {
  const portalId = contact ? contact.get('portalId') : PortalIdParser.get();
  const email = contact ? getProperty(contact, 'email') : '';
  return /*#__PURE__*/_jsx(Avatar, {
    email: email,
    size: size,
    portalId: Number(portalId) || undefined
  });
};
export default ContactAvatar;